import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_edit",
  "use": "icon-icon_general_edit-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_edit\">\n<path d=\"M32.5,10.8000002L38.2000008,16.5L20,34.5L12,37l2.3999996-8.1000004L32.5,10.8000002 M32.5,8\n\tL12.6000004,27.7999992L9,40l12.1000004-3.7000008L41,16.5L32.5,8L32.5,8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol